import {FRONTEND_VERSION_API} from "@/contants/api";
const contactResource = `${FRONTEND_VERSION_API}/contacts`;

export default $axios => ({
  store(contact) {
    return $axios.post(contactResource, contact);
  }
});